import React, { useEffect, useState } from "react";
import Select from "react-select";
import Table from "../../../core/common/dataTable/index";
import { getDisbursement } from "../../../apis/expences";
import * as XLSX from "xlsx";
import { Link } from "react-router-dom";
import { formatDate } from "../../../environment";
import { uploadFile } from "../../../apis/auth";
import { updatePaymentById } from "../../../apis/customers";

const getTodayDate = () => {
  const today = new Date();
  const offset = today.getTimezoneOffset();
  const local = new Date(today.getTime() - offset * 60000);
  return local.toISOString().split("T")[0];
};

type PaymentType = {
  value: string;
  label: string;
};

type EmiDetail = {
  id: number;
  customer_name: string;
  customer_id: number;
  loanId: number;
  emi_amount: string;
  due_date: string;
  status: string;
};

const paymentValues = {
  paymentAmount: "",
  penaltyAmount: "",
  discount: "",
  receipt_number: "",
  payment_date: getTodayDate(),
};

const EmiDetails: React.FC = () => {
  const [selectedOption, setSelectedOption] = useState<PaymentType | null>(
    null
  );
  const [selectedPaymentOption, setSelectedPaymentOption] = useState<PaymentType | null>(
    null
  );
  const [startDate, setStartDate] = useState<string>("");
  const [endDate, setEndDate] = useState<string>("");
  const [emiDetails, setEmiDetails] = useState<EmiDetail[]>([]);
  const [totalEmiAmount, setTotalEmiAmount] = useState<number>(0);
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [paymentFormData, setPaymentFormData] = useState(paymentValues);
  const [utrImage, setUtrImage] = useState<File | null>(null);
  const [error, setError] = useState<string>("");
  const [image, setImage] = useState<File | null>(null);
  const [imageUrl, setImageUrl] = useState<string>("");
  const [utrImageUrl, setUtrImageUrl] = useState<string>("");
  const [loanNewData, setLoanNewData] = useState<any>();

  const paymentType: PaymentType[] = [
    { value: "Select", label: "Select" },
    { value: "Paid", label: "Paid" },
    { value: "Pending", label: "Pending" },
    { value: "extend", label: "Extend Date" },
    { value: "balance", label: "Balance" },
  ];

  const handleSelect = (option: PaymentType | null): void => {
    setSelectedOption(option || null);
    setErrors((prevErrors) => ({ ...prevErrors, paymentMode: "" }));
  };
  const handlePaymentSelect = (option: PaymentType | null): void => {
    setSelectedPaymentOption(option || null);
    setErrors((prevErrors) => ({ ...prevErrors, paymentMode: "" }));
  };

  const [customer, setCustomer] = useState({ full_name: "" });

  const getAllData = async (): Promise<void> => {
    const loginData = sessionStorage.getItem("info");

    const data = {
      start_date: startDate,
      end_date: endDate,
      user_id: JSON.parse(loginData).id,
      type: JSON.parse(loginData).type,
      status: selectedOption?.value || null
    };
    try {
      const response = await getDisbursement(data);
      let modPaymentDetails = [];
      let srNo = 0;
      response.data.forEach((item) => {
        item.emis.map((emisItems) => {
          srNo = srNo + 1 || 0;
          emisItems.sr_no = srNo;
          emisItems.loanAccountNumber = item.customer.loanAccountNumber;
          emisItems.loan_id = item.loans.loan_id;
          emisItems.loanId = item.loan_id;
          emisItems.customer_name = item.customer.full_name;
          emisItems.customer_id = item.customer.id;
          emisItems.phoneNumber1 = item.customer.phoneNumber1;
          try {
            const guarantor = JSON.parse(item.customer.guarantor);
            emisItems.guarantorName = guarantor?.first?.name || "--";
            emisItems.guarantorMobileNumber = guarantor?.first?.mobile || "--";
          } catch (error) {
            emisItems.guarantorName = "--";
          }
          emisItems.currentBalDue = item.pendingAmountTillDate || 0;
          emisItems.finalBalance = item.totalEmiAmount - item.totalPaymentReceived || 0;
          emisItems.lastRecDate = item.lastPaymentDate || "--"
          modPaymentDetails = [emisItems, ...modPaymentDetails];
        });
      });

      const totalAmount = modPaymentDetails.reduce((sum, item) => {
        const amount = parseFloat(item.amount || 0);
        return sum + (isNaN(amount) ? 0 : amount);
      }, 0);
      setTotalEmiAmount(totalAmount);
      setEmiDetails(modPaymentDetails);
      setCustomer(response.data?.[0]?.customer || "-");
    } catch (error) {
      console.error("Error fetching EMI details:", error);
    }
  };

  useEffect(() => {
    getAllData();
  }, []);

  const columns = [
    {
      title: "SN no.",
      dataIndex: "sr_no",
      key: "sr_no",
      render: (text: number) => `${text}`,
    },
    {
      title: "Customer Account Number",
      dataIndex: "loanAccountNumber",
      key: "loanAccountNumber",
      render: (text: string) => `${text}`,
    },
    {
      title: "Loan Account Number",
      dataIndex: "loan_id",
      key: "loan_id",
      render: (text: string) => `${text}`,
    },
    {
      title: "Customer Name",
      dataIndex: "customer_name",
      key: "customer_name",
      render: (text: string) => `${text}`,
    },
    {
      title: "Customer mobile Number",
      dataIndex: "phoneNumber1",
      key: "phoneNumber1",
      render: (text: string) => `${text}`,
    },
    {
      title: "Emis no.",
      dataIndex: "emi_no",
      key: "emi_no",
      render: (text: number) => `${text}`,
    },
    {
      title: "EMI Amount",
      dataIndex: "amount",
      key: "amount",
      render: (text: string) => `₹ ${text}`,
    },
    {
      title: "Current Bal Due",
      dataIndex: "currentBalDue",
      key: "currentBalDue",
      render: (text: number) => `₹ ${text}`,
    },
    {
      title: "Last Rec. Date",
      dataIndex: "lastRecDate",
      key: "lastRecDate",
      render: (text: string) => text,
    },
    {
      title: "Final Balance",
      dataIndex: "finalBalance",
      key: "finalBalance",
      render: (text: number) => `₹ ${text}`,
    },
    {
      title: "Guarantor Name",
      dataIndex: "guarantorName",
      key: "guarantorName",
      render: (text: string) => `${text}`,
    },
    {
      title: "Guarantor Mobile Number",
      dataIndex: "guarantorMobileNumber",
      key: "guarantorMobileNumber",
      render: (text: string) => `${text}`,
    },
    {
      title: "Due Date",
      dataIndex: "due_date",
      key: "due_date",
      render: (text: string) => new Date(text).toLocaleDateString(),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text: string, record: EmiDetail) => (
        <div className="d-inline-flex">
          {text === "Paid" ? (
            <div className="btn btn-success d-flex align-items-center">
              <div>{text}</div>
            </div>
          ) : (
            <div className="btn btn-primary d-flex align-items-center">
              {text}
            </div>
          )}
        </div>
      ),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      className: "hide-in-print",
      width: 100,
      render: (text: string, record: EmiDetail) => (
        <div className="d-inline-flex">
          <div className="btn btn-primary d-flex align-items-center">
            {record?.status !== "Paid" ? (
              <div
                data-bs-toggle="modal"
                data-bs-target="#payment_modal"
                data-bs-dismiss="modal"
                onClick={() => handlepay({ data: record })}
              >
                {"Pay"}
              </div>
            ) : (
              <div>{"Paid"}</div>
            )}
          </div>
        </div>
      ),
    },
  ];

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(emiDetails);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Emi Record");
    XLSX.writeFile(workbook, "Emi Record.xlsx");
  };
  const handleOnChangePayment = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setPaymentFormData({ ...paymentFormData, [name]: value });
    setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
  };

  const paymentMode = [
    { value: "Select", label: "Select" },
    { value: "BANK", label: "BANK" },
    { value: "UPI", label: "UPI" },
    { value: "CASH", label: "CASH" },
  ];

  const { paymentAmount, penaltyAmount, discount, receipt_number, payment_date } =
    paymentFormData;

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      if (file.size > 4 * 1024 * 1024) {
        setError("Image size should be below 10 MB");
        setImage(null);
        return;
      }
      setError("");
      setImage(file);
      setUtrImage(file);
      const formData = new FormData();
      formData.append("image", file);
      const response = await uploadFile(formData);
      if (response.status === true) {
        setImageUrl(response.data.image);
        setUtrImageUrl(response.data.image);
      }
    }
  };

  const handleCancel = () => {
    setImage(null);
    setError("");
  };

  const handlepay = async (data: { data: any }) => {
    setLoanNewData(data.data);
  };
  const handlePayment = async (event: any) => {
    event.preventDefault();
    const { receipt_number, paymentAmount, payment_date } = paymentFormData;
    const newErrors: { [key: string]: string } = {};

    // if (!receipt_number?.trim()) newErrors.receipt_number = "Receipt number is required";
    if (!payment_date?.trim()) newErrors.payment_date = "Payment Date is required";
    if (!paymentAmount || isNaN(Number(paymentAmount))) newErrors.paymentAmount = "Valid payment amount is required";
    if (!selectedOption) newErrors.paymentMode = "Payment mode is required";

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setErrors({});
    const mtIdString = sessionStorage.getItem("info");
    let mtId: { id: string; user_id: string } | null = null;
    if (mtIdString) {
      try {
        mtId = JSON.parse(mtIdString);
      } catch (error) {
        console.error("Failed to parse sessionStorage info:", error);
      }
    }
    const date = new Date();
    const formattedDate = date.toISOString().split("T")[0];
    const payload = {
      paymentMode: selectedPaymentOption?.value,
      paymentAmount: Number(paymentAmount),
      paymentDate: payment_date,
      customerId: loanNewData?.customer_id,
      loanId: loanNewData?.loanId,
      emiId: loanNewData?.emi_no,
      status: "paid",
      penaltyAmount: Number(penaltyAmount),
      receipt_number: "1",
      discount: Number(discount),
      user_id: mtId?.user_id,
      utrImageUrl: utrImageUrl,
    };
    try {
      const response = await updatePaymentById(loanNewData?.customer_id, payload);
      if (response.status === true) {
        // window.location.reload();
        getAllData();
        setTimeout(() => {
          const emiButton = document.querySelector(
            ".emi_details_btn"
          ) as HTMLElement;
          if (emiButton) {
            emiButton.click();
          }
        }, 2000);
      }
      setPaymentFormData(paymentValues);
    } catch (error) {
      console.error(error, "error");
    }
  };


  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="card">
            <div className="card-body p-0">
              <div className="card-header">
                <h3>All EMI Record</h3>
                <div
                  style={{ display: "flex", gap: "1rem", marginTop: "15px", flexWrap: "wrap" }}
                >
                  <div>
                    <label>Start Date</label>
                    <input
                      type="date"
                      className="form-control form-control-sm"
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                    />
                  </div>
                  <div>
                    <label>End Date</label>
                    <input
                      type="date"
                      className="form-control form-control-sm"
                      value={endDate}
                      onChange={(e) => setEndDate(e.target.value)}
                    />
                  </div>
                  <div>
                    <label>Select Emi Type</label>
                    <Select
                      classNamePrefix="react-select"
                      options={paymentType}
                      value={selectedOption}
                      onChange={handleSelect}
                      placeholder="Select Payment Type"
                    />
                  </div>
                  <button
                    className="btn btn-primary"
                    onClick={getAllData}
                    style={{ alignSelf: "flex-end" }}
                  >
                    Fetch EMI Details
                  </button>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      margin: "20px 0px 0px 6rem",
                    }}
                  >
                    <div className="dropdown me-3">
                      <Link
                        style={{
                          background: "#3ab54bbf",
                          color: "#fff",
                        }}
                        to="#"
                        className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                        data-bs-toggle="dropdown"
                      >
                        Export
                      </Link>

                      <ul className="dropdown-menu  dropdown-menu-end p-3">
                        <li>
                          <div
                            onClick={exportToExcel}
                            className=" btn  dropdown-item rounded-1"
                          >
                            <i className="ti ti-file-type-xls me-1" />
                            Export as Excel{" "}
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card-body p-0">

              {emiDetails.length > 0 && (
                <div className="row mb-3">
                  <div className="col-12">
                    <div className="card bg-success text-white">
                      <div className="card-body">
                        <h5 className="card-title">Total EMI Amount</h5>
                        <h2 className="mb-0">₹ {totalEmiAmount.toLocaleString('en-IN')}</h2>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {emiDetails &&
                Array.isArray(emiDetails) &&
                emiDetails.length > 0 && (
                  <Table
                    dataSource={emiDetails}
                    columns={columns}
                    Selection={true}
                  />
                )}
            </div>
          </div>
          <div className="modal fade" id="payment_modal">
            <div className="modal-dialog modal-dialog-centered modal-lg">
              <div className="modal-content">
                <div className="modal-header">
                  <div className="d-flex align-items-center"></div>
                  <button
                    type="button"
                    className="btn-close custom-btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    <i className="ti ti-x" />
                  </button>
                </div>
                <form>
                  <div className="contact-grids-tab">
                    <ul className="nav nav-underline" id="myTab2" role="tablist">
                      <li className="nav-item" role="presentation">
                        <button
                          className="nav-link active"
                          id="info-tab2"
                          data-bs-toggle="tab"
                          data-bs-target="#basic-info2"
                          type="button"
                          role="tab"
                          aria-selected="true"
                        >
                          Payment Information
                        </button>
                      </li>
                    </ul>
                  </div>
                  <div className="tab-content" id="myTabContent2">
                    <div
                      className="tab-pane fade show active"
                      id="basic-info2"
                      role="tabpanel"
                      aria-labelledby="info-tab2"
                      tabIndex={0}
                    >
                      <div className="modal-body pb-0 ">
                        <div className="row">
                          <div className="col-md-6">
                            <label className="from-label">
                              Select Payment Date
                            </label>
                            <input
                              type="date"
                              required
                              name="payment_date"
                              value={payment_date}
                              onChange={handleOnChangePayment}
                              className="form-control"
                            />
                            {errors.payment_date && (
                              <small className="text-danger">
                                {errors.payment_date}
                              </small>
                            )}
                          </div>
                          <div className="profile-upload  col-md-6">
                            {!utrImage && (
                              <div className="mb-2">
                                <h6 className="mb-1">Upload Utr Image</h6>
                                <p className="fs-12">Image should be below 4 MB</p>

                                {error && <p className="text-danger">{error}</p>}
                              </div>
                            )}
                            <div className="profile-uploader d-flex align-items-center">
                              <div className="drag-upload-btn btn btn-sm btn-primary me-2">
                                {utrImage ? "Replace" : "Upload"}
                                <input
                                  type="file"
                                  className="form-control image-sign"
                                  accept="image/*"
                                  onChange={handleFileChange}
                                />
                              </div>
                              <Link
                                to="#"
                                className="btn btn-light btn-sm"
                                onClick={handleCancel}
                              >
                                Cancel
                              </Link>
                            </div>
                            {utrImage && (
                              <div className="mt-3">
                                <p>Preview:</p>
                                <img
                                  src={URL.createObjectURL(utrImage)}
                                  alt="Profile Preview"
                                  className="img-thumbnail"
                                  style={{
                                    maxWidth: "150px",
                                    maxHeight: "150px",
                                  }}
                                />
                              </div>
                            )}
                          </div>
                          <br /><br />
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Emi Amount
                                <span className="text-danger"> *</span>
                              </label>
                              <input
                                type="text"
                                name="DisbursementAmount"
                                value={loanNewData?.amount || 0}
                                className="form-control"
                                disabled
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Payment Amount
                                <span className="text-danger"> *</span>
                              </label>
                              <input
                                required
                                type="text"
                                name="paymentAmount"
                                value={paymentAmount}
                                onChange={handleOnChangePayment}
                                className="form-control"
                              />
                              {errors.paymentAmount && (
                                <small className="text-danger">
                                  {errors.paymentAmount}
                                </small>
                              )}
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Due Date
                                <span className="text-danger"> *</span>
                              </label>
                              <input
                                type="text"
                                name="utrNumber"
                                value={loanNewData?.due_date}
                                className="form-control"
                                disabled
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Penalty Amount
                                <span className="text-danger"> *</span>
                              </label>
                              <input
                                type="text"
                                name="penaltyAmount"
                                value={penaltyAmount}
                                onChange={handleOnChangePayment}
                                className="form-control"
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Discount
                                <span className="text-danger"> *</span>
                              </label>
                              <input
                                type="text"
                                name="discount"
                                value={discount}
                                onChange={handleOnChangePayment}
                                className="form-control"
                              />
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Select Payment Mode
                              </label>
                              <Select
                                classNamePrefix="react-select"
                                className="select"
                                options={paymentMode}
                                value={selectedPaymentOption}
                                onChange={handlePaymentSelect}
                                placeholder="Payment Mode"
                              />
                              {errors.paymentMode && (
                                <small className="text-danger d-block mt-1">
                                  {errors.paymentMode}
                                </small>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-outline-light border me-2"
                          data-bs-dismiss="modal"
                        >
                          Cancel
                        </button>
                        <button
                          data-bs-dismiss="modal"
                          className="btn btn-primary"
                          onClick={
                            handlePayment
                          }
                        >
                          Submit{" "}
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div >
      </div >
    </>
  );
};

export default EmiDetails;
